import BaseService from "./base.service";

export default class EbooksCategoriesService extends BaseService {
	constructor() {
		super("multimidia/ebooks/categorias");
	}
}